import React from 'react';

// ═══════════════════════════════════════════════════════════════════
// GRADIENT BACKGROUND - Animated gradient blob
// ═══════════════════════════════════════════════════════════════════

const GradientBackground = ({ intensity = 'normal' }) => {
  const blurClass = intensity === 'intense' ? 'blur-xl' : 'blur-3xl';
  const sizeClass = intensity === 'intense' ? 'w-64 h-64 md:w-[35rem] md:h-[35rem]' : 'w-56 h-56 md:w-[30rem] md:h-[30rem]';

  return (
    <>
      {/* Main gradient blob */}
      <div
        aria-hidden="true"
        className="fixed top-0 h-screen overflow-hidden inset-0 flex items-center pointer-events-none"
      >
        <div
          aria-hidden="true"
          className={`bg-layers bg-scale ${sizeClass} m-auto ${blurClass} bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-600 rounded-full`}
          style={{
            animation: 'hueRotate 8s ease-in-out infinite, scale 12s ease-in-out infinite'
          }}
        />
      </div>

      {/* Dark overlay */}
      <div
        aria-hidden="true"
        className="fixed overflow-hidden h-screen inset-0 w-full bg-[#020314] opacity-80 pointer-events-none"
      />

      {/* CSS for animations */}
      <style jsx>{`
        @keyframes hueRotate {
          0%, 100% { filter: hue-rotate(0deg); }
          50% { filter: hue-rotate(180deg); }
        }

        @keyframes scale {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }
      `}</style>
    </>
  );
};

export default GradientBackground;